/**
 * @generated SignedSource<<0484b8d3de3407085d70ecff0aad0166>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarProjectForm_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedSelectProject_user">;
  readonly " $fragmentType": "CheckoutSidebarProjectForm_buyer";
};
export type CheckoutSidebarProjectForm_buyer$key = {
  readonly " $data"?: CheckoutSidebarProjectForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarProjectForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarProjectForm_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSelectProject_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4dce9032f08c23ffa277de76d4bee828";

export default node;
